import type React from 'react';
import type { Repository } from '../../../../types';
import styles from './RowTitle.module.less';
import { Icon, Link, icons } from '../../../generic';

type RowTitleProps = { repo: Repository };

const RowTitle = ({ repo }: RowTitleProps) =>
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <span className={styles.title} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
    <Link
      to={repo.url as string}
      openInNewTab
    >
      {repo.isFork && <Icon icon={icons.codeFork} />}
      {repo.title}
    </Link>
    &nbsp;&nbsp;
  </span>;

export default RowTitle;
